var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievedPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2936_90763)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2662 4.39026C31.0966 2.36321 34.9034 2.36321 37.7338 4.39027L60.1417 20.4385C63.0322 22.5086 64.2423 26.2167 63.1293 29.5933L54.618 55.4151C53.5193 58.7481 50.406 61 46.8966 61H19.1034C15.594 61 12.4807 58.7481 11.382 55.4151L2.8707 29.5933C1.75772 26.2167 2.96783 22.5086 5.85828 20.4385L28.2662 4.39026Z",
    fill: "url(#paint0_linear_2936_90763)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2936_90763)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.417 8.41832C32.7655 8.16829 33.2345 8.16829 33.583 8.41832L58.3984 26.2243C58.7558 26.4808 58.9036 26.9407 58.7626 27.3574L49.2988 55.3206C49.1614 55.7267 48.7803 56 48.3516 56H17.6484C17.2197 56 16.8386 55.7267 16.7012 55.3206L7.23737 27.3574C7.09635 26.9407 7.24419 26.4808 7.60161 26.2243L32.417 8.41832Z",
    fill: "url(#paint1_radial_2936_90763)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.417 8.41832C32.7655 8.16829 33.2345 8.16829 33.583 8.41832L58.3984 26.2243C58.7558 26.4808 58.9036 26.9407 58.7626 27.3574L49.2988 55.3206C49.1614 55.7267 48.7803 56 48.3516 56H17.6484C17.2197 56 16.8386 55.7267 16.7012 55.3206L7.23737 27.3574C7.09635 26.9407 7.24419 26.4808 7.60161 26.2243L32.417 8.41832Z",
    fill: "url(#paint2_radial_2936_90763)",
    fillOpacity: 0.29
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.417 8.41832C32.7655 8.16829 33.2345 8.16829 33.583 8.41832L58.3984 26.2243C58.7558 26.4808 58.9036 26.9407 58.7626 27.3574L49.2988 55.3206C49.1614 55.7267 48.7803 56 48.3516 56H17.6484C17.2197 56 16.8386 55.7267 16.7012 55.3206L7.23737 27.3574C7.09635 26.9407 7.24419 26.4808 7.60161 26.2243L32.417 8.41832Z",
    fill: "url(#paint3_linear_2936_90763)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2437 25.0462L34.4283 7.24022C33.5746 6.62766 32.4254 6.62766 31.5717 7.24022L6.75628 25.0462C5.88061 25.6746 5.51839 26.8014 5.8639 27.8222L15.3277 55.7854C15.6644 56.7804 16.598 57.45 17.6484 57.45H48.3516C49.402 57.45 50.3356 56.7804 50.6723 55.7854L60.1361 27.8222C60.4816 26.8014 60.1194 25.6746 59.2437 25.0462Z",
    stroke: "url(#paint4_linear_2936_90763)",
    strokeWidth: 2.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M57.4328 22.0192L37.0735 7.32364C34.6415 5.56821 31.3585 5.56821 28.9265 7.32364L8.56723 22.0192C6.09427 23.8042 5.07152 26.9913 6.04404 29.882L13.7408 52.7594C14.6938 55.592 17.3488 57.5 20.3375 57.5H45.6625C48.6512 57.5 51.3062 55.592 52.2592 52.7594L59.956 29.882C60.9285 26.9913 59.9057 23.8042 57.4328 22.0192Z",
    stroke: "url(#paint5_linear_2936_90763)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2936_90763",
    x: 4.28442,
    y: 5.3308,
    width: 57.4312,
    height: 53.5692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.0312
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7875 0 0 0 0 0.62959 0 0 0 0 0.246094 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2936_90763"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2936_90763",
    x1: 20,
    y1: 2.57895,
    x2: 42.2932,
    y2: 55.6864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D169"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2936_90763",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33 33.0619) rotate(90) scale(39.0388 42.7925)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECC2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1A420"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2936_90763",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8491 23.9047) rotate(-41.6239) scale(27.2094 14.3467)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2936_90763",
    x1: 33,
    y1: 8,
    x2: 33,
    y2: 58.1239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#765913",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#816011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2936_90763",
    x1: 33,
    y1: 8,
    x2: 33,
    y2: 58.1239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2936_90763",
    x1: 33,
    y1: 5,
    x2: 33,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEAC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE296"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2936_90763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievedPositive);
export default __webpack_public_path__ + "static/media/achieved-positive.acaab3739e4d4ea2dac6f63536b5a4fc.svg";
export { ForwardRef as ReactComponent };